import Vue from 'vue'
import Chartist from 'vue-chartist'
import 'chartist/dist/chartist.min.css'

Vue.use(Chartist)
